var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRightChevron = function SvgRightChevron(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82994 5.28999L2.58994 1.04999C2.49698 0.956266 2.38638 0.881872 2.26452 0.831103C2.14266 0.780334 2.01195 0.754196 1.87994 0.754196C1.74793 0.754196 1.61723 0.780334 1.49537 0.831103C1.37351 0.881872 1.26291 0.956266 1.16994 1.04999C0.983692 1.23736 0.87915 1.49081 0.87915 1.75499C0.87915 2.01918 0.983692 2.27263 1.16994 2.45999L4.70994 5.99999L1.16994 9.53999C0.983692 9.72736 0.87915 9.98081 0.87915 10.245C0.87915 10.5092 0.983692 10.7626 1.16994 10.95C1.26338 11.0427 1.3742 11.116 1.49604 11.1658C1.61787 11.2155 1.74834 11.2408 1.87994 11.24C2.01155 11.2408 2.14201 11.2155 2.26385 11.1658C2.38569 11.116 2.4965 11.0427 2.58994 10.95L6.82994 6.70999C6.92367 6.61703 6.99806 6.50643 7.04883 6.38457C7.0996 6.26271 7.12574 6.13201 7.12574 5.99999C7.12574 5.86798 7.0996 5.73728 7.04883 5.61542C6.99806 5.49356 6.92367 5.38296 6.82994 5.28999Z",
    fill: "#18379A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightChevron, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-chevron.3b5d18e0.svg";
export { ForwardRef as ReactComponent };